import Delayed from 'components/delayed'
import SocialConnection from './social-connection'
import GameConnection from './game-connection'
import WalletConnection from './wallet-connection'
import LootManagement from './loot-management'

import TabsIcon from 'components/atomic/tabs-icon'
import LootTabIcon from 'components/icon/loot-tab'
import SocialConnectionsTabIcon from 'components/icon/social-connections-tab'
import GameConnectionsTabIcon from 'components/icon/game-connections-tab'
import WalletTabIcon from 'components/icon/wallet-tab'
import { Container } from 'components/atomic'

interface ConnectionsProps {
  clawsNftCount: number
  paidProducts: Array<any>
  hasGameAccess: boolean
  loadingStardustWallet: boolean
  isSmallScreen?: boolean
  refetchInventoryData: () => void
}

const Connections = ({
  clawsNftCount,
  paidProducts,
  hasGameAccess,
  loadingStardustWallet,
  isSmallScreen,
  refetchInventoryData,
}: ConnectionsProps) => {
  return (
    <div className="mt-10">
      <TabsIcon activeIndex={0}>
        {/* Loot box Tab */}
        <TabsIcon.Panel label="Load up for action" tabRender={<LootTabIcon />}>
          <Delayed waitBeforeShow={200}>
            <Container className="flex justify-center">
              <LootManagement
                paidProducts={paidProducts}
                hasDayZeroPatch={clawsNftCount > 0}
                refetchInventoryData={refetchInventoryData}
                hasGameAccess={hasGameAccess}
              />
            </Container>
          </Delayed>
        </TabsIcon.Panel>

        {/* Social Connections Tab */}
        <TabsIcon.Panel label="Drop into the fray" tabRender={<SocialConnectionsTabIcon />}>
          <div
            className={`grid w-full max-w-[1440px] px-5 md:px-8 ${
              isSmallScreen ? 'grid-cols-1 2lg:grid-cols-2' : 'grid-cols-1 lg:grid-cols-2 xl:grid-cols-3'
            } min-h-[276px]`}
          >
            <Delayed waitBeforeShow={200}>
              <SocialConnection isSmallScreen={isSmallScreen} />
            </Delayed>
          </div>
        </TabsIcon.Panel>

        {/* Game Connections Tab */}
        <TabsIcon.Panel label="Embrace your Greatness" tabRender={<GameConnectionsTabIcon />}>
          <div
            className={`grid w-full max-w-[1440px] px-5 md:px-8 ${
              isSmallScreen ? 'grid-cols-1 2lg:grid-cols-2' : 'grid-cols-1 lg:grid-cols-2 xl:grid-cols-3'
            } min-h-[196px]`}
          >
            <Delayed waitBeforeShow={200}>
              <GameConnection isSmallScreen={isSmallScreen} />
            </Delayed>
          </div>
        </TabsIcon.Panel>

        {/* Wallet Tab */}
        <TabsIcon.Panel label="Embrace your Greatness" tabRender={<WalletTabIcon />}>
          <div className={`block ${isSmallScreen ? '2lg:flex' : 'md:flex'} min-h-[280px] justify-center`}>
            <Delayed waitBeforeShow={200}>
              <WalletConnection loadingStardustWallet={loadingStardustWallet} isSmallScreen={isSmallScreen} />
            </Delayed>
          </div>
        </TabsIcon.Panel>
      </TabsIcon>
    </div>
  )
}

export default Connections
